import React, { useState, useCallback } from 'react';
import { Accordion } from 'semantic-ui-react';

import Layout from '../components/layout';
import SEO from '../components/seo';
import styled from 'styled-components';

const rows = [
  {
    title: 'Introduction',
    body: (
      <>
        Welcome to <strong>Foongit (Pty) Ltd</strong>.
        Foongit (Pty) Ltd (“us”, “we”, or “our”) operates <a href="https://foongit.com/">https://foongit.com/</a> and Foongit mobile application (hereinafter referred to as “<strong>Service</strong>”).
        Our Privacy Policy governs your visit to <a href="https://foongit.com/">https://foongit.com/</a> and Foongit mobile application, and explains how we collect, safeguard and disclose information that results from your use of our Service.
        We use your data to provide and improve Service. By using Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.
        Our Terms and Conditions (“<strong>Terms</strong>”) govern all use of our Service and together with the Privacy Policy constitutes your agreement with us (“<strong>agreement</strong>”).
      </>
    ),
  }, {
    title: 'Definitions',
    body: (
      <>
        <strong>SERVICE</strong> means the <a href="https://foongit.com/">https://foongit.com/</a> website and Foongit mobile application operated by Foongit (Pty) Ltd.
        <br />
        <strong>PERSONAL</strong> DATA means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).
        <br />
        <strong>USAGE DATA</strong> is data collected automatically either generated by the use of Service or from Service infrastructure itself (for example, the duration of a page visit).
        <br />
        <strong>COOKIES</strong> are small files stored on your device (computer or mobile device).
        <br />
        <strong>DATA CONTROLLER</strong> means a natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal data are, or are to be, processed. For the purpose of this Privacy Policy, we are a Data Controller of your data.
        <br />
        <strong>DATA PROCESSORS (OR SERVICE PROVIDERS)</strong> means any natural or legal person who processes the data on behalf of the Data Controller. We may use the services of various Service Providers in order to process your data more effectively.
        <br />
        <strong>DATA SUBJECT</strong> is any living individual who is the subject of Personal Data.
        <br />
        <strong>THE USER</strong> is the individual using our Service. The User corresponds to the Data Subject, who is the subject of Personal Data.
      </>
    ),
  }, {
    title: 'Information Collection and Use',
    body: (
      <>
        We collect several different types of information for various purposes to provide and improve our Service to you.
      </>
    ),
  }, {
    title: 'Types of Data Collected',
    body: (
      <>
        <strong>Personal Data</strong><br />
        While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (“<strong>Personal Data</strong>”). Personally identifiable information may include, but is not limited to:
        <ul>
          <li>Email address</li>
          <li>First name and last name</li>
          <li>Phone number</li>
          <li>Address, State, Province, ZIP/Postal code, City</li>
          <li>Cookies and Usage Data</li>
        </ul>
        We may use your Personal Data to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link.
        <br />
        <br />
        <strong>Usage Data</strong><br />
        We may also collect information that your browser sends whenever you visit our Service or when you access Service by or through a mobile device (“<strong>Usage Data</strong>”).
        This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.

        When you access Service with a mobile device, this Usage Data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.
        <br />
        <br />
        <strong>Location Data</strong><br />
        We may use and store information about your location if you give us permission to do so (“<strong>Location Data</strong>”). We use this data to provide features of our Service, to improve and customize our Service.
        You can enable or disable location services when you use our Service at any time by way of your device settings.
        <br />
        <br />
        <strong>Tracking Cookies Data</strong><br />
        We use cookies and similar tracking technologies to track the activity on our Service and we hold certain information.
        Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Other tracking technologies are also used such as beacons, tags and scripts to collect and track information and to improve and analyze our Service.
        You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.
        <br />
        <br />
        Examples of Cookies we use:
        <ul>
          <li><strong>Session Cookies:</strong> We use Session Cookies to operate our Service.</li>
          <li><strong>Preference Cookies:</strong> We use Preference Cookies to remember your preferences and various settings.</li>
          <li><strong>Security Cookies:</strong> We use Security Cookies for security purposes.</li>
          <li><strong>Advertising Cookies:</strong> Advertising Cookies are used to serve you with advertisements that may be relevant to you and your interests.</li>
        </ul>
        <strong>Other Data</strong>
        While using our Service, we may also collect the following information: sex, age, date of birth, place of birth, passport details, citizenship, registration at place of residence and actual address, telephone number (work, mobile), details of documents on education, qualification, professional training, employment agreements,
        non-disclosure agreements, information on bonuses and compensation, information on marital status, family members, social security (or other taxpayer identification) number, office location and other data.
      </>
    ),
  }, {
    title: 'Use of Data',
    body: (
      <>
        Foongit (Pty) Ltd uses the collected data for various purposes:
        <ul>
          <li>to provide and maintain our Service</li>
          <li>to notify you about changes to our Service</li>
          <li>to allow you to participate in interactive features of our Service when you choose to do so</li>
          <li>to provide customer support</li>
          <li>to gather analysis or valuable information so that we can improve our Service</li>
          <li>to monitor the usage of our Service</li>
          <li>to detect, prevent and address technical issues</li>
          <li>to fulfill any other purpose for which you provide it</li>
          <li>to carry out our obligations and enforce our rights arising from any contracts entered into between you and us, including for billing and collection</li>
          <li>to provide you with notices about your account and/or subscription, including expiration and renewal notices, email-instructions, etc.</li>
          <li>to provide you with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information</li>
          <li>in any other way we may describe when you provide the information</li>
          <li>for any other purpose with your consent.</li>
        </ul>
      </>
    ),
  }, {
    title: 'Retention of Data',
    body: (
      <>
        We will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
        We will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer time periods.
      </>
    ),
  }, {
    title: 'Transfer of Data',
    body: (
      <>
        Your information, including Personal Data, may be transferred to – and maintained on – computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.
        If you are located outside United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to United States and process it there.
        Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.
        Foongit (Pty) Ltd will take all the steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organisation or a country unless there are adequate controls in place including the security of your data and other personal information.
      </>
    ),
  }, {
    title: 'Disclosure of Data',
    body: (
      <>
        We may disclose personal information that we collect, or you provide:
        <br />
        <br />
        <strong>Disclosure for Law Enforcement</strong>
        <br />
        Under certain circumstances, we may be required to disclose your Personal Data if required to do so by law or in response to valid requests by public authorities.
        <br />
        <br />
        <strong>Business Transaction</strong>
        <br />
        If we or our subsidiaries are involved in a merger, acquisition or asset sale, your Personal Data may be transferred.
        <br />
        <br />
        <strong>Other cases. We may disclose your information also:</strong>
        <ul>
          <li>to our subsidiaries and affiliates</li>
          <li>to contractors, service providers, and other third parties we use to support our business</li>
          <li>to fulfill the purpose for which you provide it</li>
          <li>for the purpose of including your company’s logo on our website</li>
          <li>for any other purpose disclosed by us when you provide the information</li>
          <li>with your consent in any other cases</li>
          <li>if we believe disclosure is necessary or appropriate to protect the rights, property, or safety of the Company, our customers, or others</li>
        </ul>
      </>
    ),
  }, {
    title: 'Security of Data',
    body: (
      <>
        The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
      </>
    ),
  }, {
    title: 'Service Providers',
    body: (
      <>
        We may employ third party companies and individuals to facilitate our Service (“<strong>Service Providers</strong>”), provide Service on our behalf, perform Service-related services or assist us in analysing how our Service is used.
        These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
      </>
    ),
  }, {
    title: 'Analytics',
    body: (
      <>
        We may use third-party Service Providers to monitor and analyze the use of our Service.
        <br />
        <br />
        <strong>Google Analytics</strong>
        <br />
        Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our Service. This data is shared with other Google services. Google may use the collected data to contextualise and personalise the ads of its own advertising network.
        For more information on the privacy practices of Google, please visit the Google Privacy Terms web page: <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a>
        We also encourage you to review the Google's policy for safeguarding your data: <a href="https://support.google.com/analytics/answer/6004245">https://support.google.com/analytics/answer/6004245</a>.
        <br />
        <br />
        <strong>Firebase</strong>
        <br />
        Firebase is analytics service provided by Google Inc.
        You may opt-out of certain Firebase features through your mobile device settings, such as your device advertising settings or by following the instructions provided by Google in their Privacy Policy: <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a>
        For more information on what type of information Firebase collects, please visit the Google Privacy Terms web page: <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a>
        <br />
        <br />
        <strong>Fathom Analytics</strong>
        <br />
        Fathom Analytics is analytics service provided by Conva Ventures Inc. You can find their Privacy Policy here: https://usefathom.com/privacy/
        <br />
        <br />
        <strong>Piwik / Matomo</strong>
        <br />
        Piwik or Matomo is a web analytics service. You can visit their Privacy Policy page here: <a href="https://matomo.org/privacy-policy">https://matomo.org/privacy-policy</a>
        <br />
        <br />
        <strong>Clicky</strong>
        <br />
        Clicky is a web analytics service. Read the Privacy Policy for Clicky here: <a href="https://clicky.com/terms">https://clicky.com/terms</a>
        <br />
        <br />
        <strong>Cloudflare analytics</strong>
        <br />
        Cloudflare analytics is a web analytics service operated by Cloudflare Inc. Read the Privacy Policy here: <a href="https://www.cloudflare.com/privacypolicy/">https://www.cloudflare.com/privacypolicy/</a>
        <br />
        <br />
        <strong>Segment.io</strong>
        <br />
        Segment.io is a web traffic analysis tool. You can read the Privacy Policy for Segment.io here: <a href="https://segment.com/legal/privacy/.">https://segment.com/legal/privacy/.</a>
        <br />
        <br />
        <strong>Statcounter</strong>
        <br />
        Statcounter is a web traffic analysis tool. You can read the Privacy Policy for Statcounter here: <a href="https://statcounter.com/about/legal/">https://statcounter.com/about/legal/</a>
        <br />
        <br />
        <strong>Flurry Analytics</strong>
        <br />
        Flurry Analytics service is provided by Yahoo! Inc.
        You can opt-out from Flurry Analytics service to prevent Flurry Analytics from using and sharing your information by visiting the Flurry's Opt-out page: <a href="https://dev.flurry.com/secure/optOut.do">https://dev.flurry.com/secure/optOut.do</a>
        For more information on the privacy practices and policies of Yahoo!, please visit their Privacy Policy page: <a href="https://policies.yahoo.com/us/en/yahoo/privacy/policy/index.htm">https://policies.yahoo.com/us/en/yahoo/privacy/policy/index.htm</a>
        <br />
        <br />
        <strong>Mixpanel</strong>
        <br />
        Mixpanel is provided by Mixpanel Inc.
        You can prevent Mixpanel from using your information for analytics purposes by opting-out. To opt-out of Mixpanel service, please visit this page: <a href="https://mixpanel.com/optout/">https://mixpanel.com/optout/</a>
        For more information on what type of information Mixpanel collects, please visit the Terms of Use page of Mixpanel: <a href="https://mixpanel.com/terms/">https://mixpanel.com/terms/</a>
        <br />
        <br />
        <strong>Unity Analytics</strong>
        <br />
        Unity Analytics is provided by Unity Technologies.
        For more information on what type of information Unity Analytics collects, please visit their Privacy Policy page: <a href="https://unity3d.com/legal/privacy-policy">https://unity3d.com/legal/privacy-policy</a>
        <br />
        <br />
        <strong>Ackee</strong>
        <br />
        Ackee is a web traffic analysis tool
        For more information on what type of information Ackee collects, please visit their Terms of Service page: <a href="https://electerious.com/terms_of_service.html">https://electerious.com/terms_of_service.html</a>
      </>
    ),
  }, {
    title: 'Advertising',
    body: (
      <>
        We may use third-party Service Providers to show advertisements to you to help support and maintain our Service.
        <br />
        <br />
        <strong>Google AdSense DoubleClick Cookie</strong>
        <br />
        Google, as a third party vendor, uses cookies to serve ads on our Service. Google's use of the DoubleClick cookie enables it and its partners to serve ads to our users based on their visit to our Service or other websites on the Internet.
        You may opt out of the use of the DoubleClick Cookie for interest-based advertising by visiting the Google Ads Settings web page: <a href="http://www.google.com/ads/preferences/">http://www.google.com/ads/preferences/</a>
        <br />
        <br />
        <strong>Bing Ads</strong>
        <br />
        Bing Ads is an advertising service provided by Microsoft Inc.
        You can opt-out from Bing Ads by following the instructions on Bing Ads Opt-out page: <a href="https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads">https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads</a>
        For more information about Bing Ads, please visit their Privacy Policy: <a href="https://privacy.microsoft.com/en-us/PrivacyStatement">https://privacy.microsoft.com/en-us/PrivacyStatement</a>
        <br />
        <br />
        <strong>AdMob by Google</strong>
        <br />
        AdMob by Google is provided by Google Inc.
        You can opt-out from the AdMob by Google service by following the instructions described by Google: <a href="https://support.google.com/ads/answer/2662922?hl=en">https://support.google.com/ads/answer/2662922?hl=en</a>.
        For more information on how Google uses the collected information, please visit the “How Google uses data when you use our partners' sites or app” page: <a href="http://www.google.com/policies/privacy/partners/">http://www.google.com/policies/privacy/partners/</a> or visit the Privacy Policy of Google: <a href="http://www.google.com/policies/privacy/">http://www.google.com/policies/privacy/</a>
        <br />
        <br />
        <strong>AdButler</strong>
        <br />
        AdButler is an advertising service provided by Sparklit Networks Inc.
        For more information about AdButler, please visit their Privacy Policy: <a href="https://www.sparklit.com/agreements.spark?agreement=privacy">https://www.sparklit.com/agreements.spark?agreement=privacy</a>
        <br />
        <br />
        <strong>Unity Ads</strong>
        <br />
        Unity Ads is provided by Unity Technologies.
        You can opt-out from Unity Ads service by following the instructions as described by Unity Technologies on their Privacy Policy page: <a href="https://unity3d.com/legal/privacy-policy">https://unity3d.com/legal/privacy-policy</a>
        For more information about Unity Technologies, please visit Unity Technologies Privacy Policy: <a href="https://unity3d.com/legal/privacy-policy">https://unity3d.com/legal/privacy-policy</a>
      </>
    ),
  }, {
    title: 'Behavioral Remarketing',
    body: (
      <>
        Foongit (Pty) Ltd uses remarketing services to advertise on third party websites to you after you visited our Service. We and our third-party vendors use cookies to inform, optimise and serve ads based on your past visits to our Service.
        <br />
        <br />
        <strong>Google Ads (AdWords)</strong>
        <br />
        Google Ads (AdWords) remarketing service is provided by Google Inc.
        You can opt-out of Google Analytics for Display Advertising and customize the Google Display Network ads by visiting the Google Ads Settings page: <a href="http://www.google.com/settings/ads">http://www.google.com/settings/ads</a>
        Google also recommends installing the Google Analytics Opt-out Browser Add-on – <a href="https://tools.google.com/dlpage/gaoptout">https://tools.google.com/dlpage/gaoptout</a> – for your web browser. Google Analytics Opt-out Browser Add-on provides visitors with the ability to prevent their data from being collected and used by Google Analytics.
        For more information on the privacy practices of Google, please visit the Google Privacy Terms web page: <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a>
        <br />
        <br />
        <strong>Bing Ads Remarketing</strong>
        <br />
        Bing Ads remarketing service is provided by Microsoft Inc.
        You can opt-out of Bing Ads interest-based ads by following their instructions: <a href="https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads">https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads</a>
        You can learn more about the privacy practices and policies of Microsoft by visiting their Privacy Policy page: <a href="https://privacy.microsoft.com/en-us/PrivacyStatement">https://privacy.microsoft.com/en-us/PrivacyStatement</a>
        <br />
        <br />
        <strong>Twitter</strong>
        <br />
        Twitter remarketing service is provided by Twitter Inc.
        You can opt-out from Twitter's interest-based ads by following their instructions: <a href="https://support.twitter.com/articles/20170405">https://support.twitter.com/articles/20170405</a>
        You can learn more about the privacy practices and policies of Twitter by visiting their Privacy Policy page: <a href="https://twitter.com/privacy">https://twitter.com/privacy</a>
        <br />
        <br />
        <strong>Facebook</strong>
        <br />
        Facebook remarketing service is provided by Facebook Inc.
        You can learn more about interest-based advertising from Facebook by visiting this page: <a href="https://www.facebook.com/help/164968693837950">https://www.facebook.com/help/164968693837950</a>
        To opt-out from Facebook's interest-based ads, follow these instructions from Facebook: <a href="https://www.facebook.com/help/568137493302217">https://www.facebook.com/help/568137493302217</a>
        Facebook adheres to the Self-Regulatory Principles for Online Behavioural Advertising established by the Digital Advertising Alliance. You can also opt-out from Facebook and other participating companies through the Digital Advertising Alliance in the USA <a href="http://www.aboutads.info/choices/">http://www.aboutads.info/choices/</a>, the Digital Advertising Alliance of Canada in Canada <a href="http://youradchoices.ca/">http://youradchoices.ca/</a> or the European Interactive Digital Advertising Alliance in Europe <a href="http://www.youronlinechoices.eu/">http://www.youronlinechoices.eu/</a>, or opt-out using your mobile device settings.
        For more information on the privacy practices of Facebook, please visit Facebook's Data Policy: <a href="https://www.facebook.com/privacy/explanation">https://www.facebook.com/privacy/explanation</a>
        <br />
        <br />
        <strong>Pinterest</strong>
        <br />
        Pinterest remarketing service is provided by Pinterest Inc.
        You can opt-out from Pinterest's interest-based ads by enabling the “Do Not Track” functionality of your web browser or by following Pinterest instructions: <a href="http://help.pinterest.com/en/articles/personalization-and-data">http://help.pinterest.com/en/articles/personalization-and-data</a>.
        You can learn more about the privacy practices and policies of Pinterest by visiting their Privacy Policy page: <a href="https://about.pinterest.com/en/privacy-policy">https://about.pinterest.com/en/privacy-policy</a>
      </>
    ),
  }, {
    title: 'Payments',
    body: (
      <>
        We may provide paid products and/or services within Service. In that case, we use third-party services for payment processing (e.g. payment processors).
        We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, Mastercard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information.
        The payment processors we work with are:
        <br />
        <br />
        <strong>Ozow</strong>
        <br />
        Their Privacy Policy can be viewed at <a href="https://ozow.com/privacy-policy/">https://ozow.com/privacy-policy/</a>
        <br />
        <br />
        <strong>PayGate (DPO)</strong>
        <br />
        Their Privacy Policy can be viewed at <a href="https://www.paygate.co.za/privacy-policy/">https://www.paygate.co.za/privacy-policy/</a>
        <br />
        <br />
        <strong>PayPal or Braintree</strong>
        <br />
        Their Privacy Policy can be viewed at <a href="https://www.paypal.com/webapps/mpp/ua/privacy-full">https://www.paypal.com/webapps/mpp/ua/privacy-full</a>

        <br />
        <br />
        <strong>FastSpring</strong>
        <br />
        Their Privacy Policy can be viewed at <a href="http://fastspring.com/privacy/">http://fastspring.com/privacy/</a>

        <br />
        <br />
        <strong>Apple Store In-App Payments</strong>
        <br />
        Their Privacy Policy can be viewed at: <a href="https://www.apple.com/legal/privacy/en-ww/">https://www.apple.com/legal/privacy/en-ww/</a> / <a href="https://payments.google.com/payments/apis-secure/u/0/get_legal_document?ldo=0&ldt=privacynotice&ldl=en">https://payments.google.com/payments/apis-secure/u/0/get_legal_document?ldo=0&ldt=privacynotice&ldl=en</a>

        <br />
        <br />
        <strong>Google Play In-App Payments</strong>
        <br />
        Their Privacy Policy can be viewed at: <a href="https://policies.google.com/privacy?hl=en&gl=us">https://policies.google.com/privacy?hl=en&gl=us</a> / <a href="https://support.apple.com/en-us/HT203027">https://support.apple.com/en-us/HT203027</a>

        <br />
        <br />
        <strong>Stripe</strong>
        <br />
        Their Privacy Policy can be viewed at: <a href="https://stripe.com/us/privacy">https://stripe.com/us/privacy</a>

        <br />
        <br />
        <strong>2Checkout</strong>
        <br />
        Their Privacy Policy can be viewed at: <a href="https://www.2checkout.com/legal/privacy/">https://www.2checkout.com/legal/privacy/</a>

        <br />
        <br />
        <strong>Adyen</strong>
        <br />
        Their Terms and conditions can be viewed at <a href="https://www.adyen.com/legal/terms-and-conditions">https://www.adyen.com/legal/terms-and-conditions</a>

        <br />
        <br />
        <strong>Alipay</strong>
        <br />
        Their Privacy Policy can be viewed at: <a href="https://render.alipay.com/p/f/agreementpages/alipayglobalprivacypolicy.html">https://render.alipay.com/p/f/agreementpages/alipayglobalprivacypolicy.html</a>

        <br />
        <br />
        <strong>Authorize.net</strong>
        <br />
        Their Privacy Policy can be viewed at: <a href="https://www.authorize.net/about-us/privacy/">https://www.authorize.net/about-us/privacy/</a>

        <br />
        <br />
        <strong>Elavon</strong>
        <br />
        Their Privacy Policy can be viewed at: <a href="https://www.elavon.com/privacy-pledge.html">https://www.elavon.com/privacy-pledge.html</a>

        <br />
        <br />
        <strong>First Data</strong>
        <br />
        Their Privacy Policy can be viewed at: <a href="https://www.firstdata.com/en_us/privacy.html">https://www.firstdata.com/en_us/privacy.html</a>

        <br />
        <br />
        <strong>Go Cardless</strong>
        <br />
        Their Privacy Policy can be viewed at: <a href="https://gocardless.com/legal/privacy">https://gocardless.com/legal/privacy</a>

        <br />
        <br />
        <strong>Klarna</strong>
        <br />
        Their Services Terms, Privacy Policy and Buyer Protection Policy can be viewed at <a href="https://www.klarna.com/us/legal/">https://www.klarna.com/us/legal/</a>

        <br />
        <br />
        <strong>Moneris</strong>
        <br />
        Their Privacy Policy can be viewed at: <a href="https://www.moneris.com/legal/privacy-policy">https://www.moneris.com/legal/privacy-policy</a>

        <br />
        <br />
        <strong>Plaid</strong>
        <br />
        Their End User Privacy Policy, Cookie Policy and Privacy Statement can be viewed at <a href="https://plaid.com/legal/">https://plaid.com/legal/</a>

        <br />
        <br />
        Sage <strong>Pay</strong>
        <br />
        Their Privacy Policy can be viewed at: <a href="https://www.sagepay.co.uk/policies/privacy-policy">https://www.sagepay.co.uk/policies/privacy-policy</a>

        <br />
        <br />
        <strong>Square</strong>
        <br />
        Their Privacy Policy can be viewed at: <a href="https://squareup.com/us/en/legal/general/privacy">https://squareup.com/us/en/legal/general/privacy</a>

        <br />
        <br />
        <strong>Verifone</strong>
        <br />
        Their Privacy Policy can be viewed at: <a href="https://www.verifone.com/en/privacy">https://www.verifone.com/en/privacy</a>

        <br />
        <br />
        <strong>WePay</strong>
        <br />
        Their Privacy Policy can be viewed at: <a href="https://go.wepay.com/privacy-policy">https://go.wepay.com/privacy-policy</a>

        <br />
        <br />
        <strong>WorldPay</strong>
        <br />
        Their Privacy Policy can be viewed at: <a href="https://online.worldpay.com/terms/privacy">https://online.worldpay.com/terms/privacy</a>

        <br />
        <br />
        <strong>WeChat</strong>
        <br />
        Their Privacy Policy can be viewed at: <a href="https://www.wechat.com/en/privacy_policy.html">https://www.wechat.com/en/privacy_policy.html</a>
      </>
    ),
  }, {
    title: 'Links to Other Sites',
    body: (
      <>
        Our Service may contain links to other sites that are not operated by us. If you click a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.
        We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
      </>
    ),
  }, {
    title: "Children's Privacy",
    body: (
      <>
        Our Services are not intended for use by children under the age of 13 (“<strong>Children</strong>”).
        We do not knowingly collect personally identifiable information from Children under 13. If you become aware that a Child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from Children without verification of parental consent, we take steps to remove that information from our servers.
      </>
    ),
  }, {
    title: 'Changes to This Privacy Policy',
    body: (
      <>
        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
        We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update “effective date” at the top of this Privacy Policy.
        You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
      </>
    ),
  }, {
    title: 'Contact Us',
    body: (
      <>
        If you have any questions about this Privacy Policy, please contact us:
        <br />
        By email: <a href="mailto:hello@foongit.com">hello@foongit.com</a>
        <br />
        By visiting this page on our website: <a href="https://foongit.com/contact">https://foongit.com/contact</a>
        <br />
        By phone number: 0618362759
        <br />
        By mail: 3 Fir Steet Mayberry Park, Alberton
      </>
    ),
  }
];

const PrivacyPolicy = ({ className }) => {
  const [activeAccordionIndex, setActiveAccordionIndex] = useState(-1);

  const onAccordionClick = useCallback((_e, titleProps) => {
    const { index, active } = titleProps;

    setActiveAccordionIndex(active ? -1 : index);
  }, [activeAccordionIndex]);

  return (
    <Layout>
      <SEO title="Privacy Policy" />
      <div className={className}>
        <div className="content">
          <h2>Privacy Policy</h2>
          <Accordion
            className="registrations"
            fluid
            styled
          >
            {rows.map(({ title, body }, index) => (
              <>
                <Accordion.Title
                  key={`title-${index}`}
                  active={activeAccordionIndex === index}
                  index={index}
                  onClick={onAccordionClick}
                >
                  {title}
                </Accordion.Title>
                <Accordion.Content key={`content-${index}`} active={activeAccordionIndex === index}>
                  {body}
                </Accordion.Content>
              </>
            ))}
          </Accordion>
        </div>
      </div>
    </Layout>
  );
}

export default styled(PrivacyPolicy)`
  display: flex;
  align-items: center;
  justify-content: center;

  .content {
    border-radius: 10px;
    margin: 3rem;
    padding: 12px;
    width: 100%;
  }
`;
